import React from 'react'

import Link from '@aletheia/common/components/Link'
import MetabaseEmbed from '../MetabaseEmbed'

import { PayoutChartDataPoint, PayoutsByFund } from './PayoutsByFund'

export const StatisticsOverview = ({
  data,
}: {
  data?: PayoutChartDataPoint[]
}) => {
  return (
    <>
      <MetabaseEmbed
        embedType="chart"
        src="https://dashboard.effectivealtruism.org/public/question/4c99d9dd-0ed3-4b9d-810d-a4bef273659b"
        title="Donations to EA Funds"
        helpText={
          <>
            Includes donations to the four principal EA Funds (i.e.{' '}
            <Link href="/funds/[slug]" as="/funds/global-development">
              Global Health and Development Fund
            </Link>
            ,{' '}
            <Link href="/funds/[slug]" as="/funds/animal-welfare">
              Animal Welfare Fund
            </Link>
            ,{' '}
            <Link href="/funds/[slug]" as="/funds/far-future">
              Long-Term Future Fund
            </Link>
            , and{' '}
            <Link href="/funds/[slug]" as="/funds/ea-community">
              EA Infrastructure Fund
            </Link>
            ).
            <br />
            <br />
            <Link href="/stats/donations">
              {' '}
              View donations broken down by fund
            </Link>
          </>
        }
      />
      <MetabaseEmbed
        embedType="chart"
        title="Monthly active donors"
        src="https://dashboard.effectivealtruism.org/public/question/3b614bc7-8a3c-482c-bbcb-a1dbd09af1d2"
        helpText={
          <>
            Number of unique people who have made at least one donation in the
            given month.{' '}
            <Link href="/stats/[...path]" as="/stats/usage">
              View more usage stats
            </Link>
            .
          </>
        }
      />

      {data && <PayoutsByFund data={data} />}
    </>
  )
}

export default StatisticsOverview
